import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Calendar, Clock, ArrowLeft, ArrowRight } from 'lucide-react';
import { BLOG_POSTS } from '../../utils/constants';

const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(dateString).toLocaleDateString(undefined, options);
};

const renderContent = (content) =>
  content
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line, i) =>
      line.startsWith('## ')
        ? <h2 key={i}>{line.slice(3)}</h2>
        : <p key={i}>{line}</p>
    );

const BlogPost = () => {
  const { postId } = useParams();
  const navigate = useNavigate();

  const post = BLOG_POSTS.find((p) => String(p.id) === String(postId));
  const postIndex = BLOG_POSTS.findIndex((p) => String(p.id) === String(postId));
  const nextPost = postIndex >= 0 && postIndex < BLOG_POSTS.length - 1 ? BLOG_POSTS[postIndex + 1] : null;
  const prevPost = postIndex > 0 ? BLOG_POSTS[postIndex - 1] : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [postId]);

  if (!post) {
    return (
      <div className="r-root blog-page" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="r-page-bg" aria-hidden="true" />
        <div style={{ textAlign: 'center' }}>
          <h1 className="r-head">Post not found</h1>
          <p className="r-sub" style={{ margin: '12px auto 24px' }}>
            This article doesn&apos;t exist or hasn&apos;t been published yet.
          </p>
          <button type="button" className="btn-primary fh-cta" onClick={() => navigate('/blog')}>
            <span>Back to Blog</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="r-root blog-page">
      <div className="r-page-bg" aria-hidden="true" />
      <div className="r-wrap">
        <article className="post-wrap">
          <button type="button" className="post-back" onClick={() => navigate('/blog')}>
            <ArrowLeft className="w-4 h-4" /> Back to Blog
          </button>

          <div className="blog-meta">
            <span className="blog-badge">{post.category}</span>
            <span><Calendar className="w-3 h-3" style={{ display: 'inline', verticalAlign: '-2px', marginRight: 4 }} />{formatDate(post.date)}</span>
            <span><Clock className="w-3 h-3" style={{ display: 'inline', verticalAlign: '-2px', marginRight: 4 }} />{post.readTime}</span>
          </div>

          <h1 className="post-title">{post.title}</h1>
          <p className="post-excerpt">{post.excerpt}</p>

          <div className="post-author">
            <div className="post-author-avatar">{post.author.charAt(0)}</div>
            <div>
              <div className="post-author-name">{post.author}</div>
              <div className="post-author-org">Feral Techlabs</div>
            </div>
          </div>

          <div className="post-body">
            {renderContent(post.content)}
          </div>

          <div className="post-tags">
            {post.tags.map((tag) => (
              <span key={tag} className="post-tag">{tag}</span>
            ))}
          </div>

          <div className="post-nav">
            {prevPost ? (
              <button type="button" className="post-nav-card" onClick={() => navigate(`/blog/${prevPost.id}`)}>
                <div className="post-nav-label"><ArrowLeft className="w-3 h-3" style={{ display: 'inline', verticalAlign: '-1px', marginRight: 4 }} />Previous</div>
                <div className="post-nav-title">{prevPost.title}</div>
              </button>
            ) : <div />}
            {nextPost && (
              <button type="button" className="post-nav-card" style={{ textAlign: 'right' }} onClick={() => navigate(`/blog/${nextPost.id}`)}>
                <div className="post-nav-label">Next<ArrowRight className="w-3 h-3" style={{ display: 'inline', verticalAlign: '-1px', marginLeft: 4 }} /></div>
                <div className="post-nav-title">{nextPost.title}</div>
              </button>
            )}
          </div>
        </article>
      </div>
    </div>
  );
};

export default BlogPost;
